import React, {Component} from 'react';
import { Link } from 'react-router-dom';

class Hosting extends Component {
    render() {
        return ( 
            <section className="HomeHosting section">
                <div className="HomeHostingBg"></div>
                <div className="container has-text-centered">
                    <div className="columns">
                        <div className="HomeHostingImageColumn column">
                            <img className="HomeHostingImage" src="/Images/upload.svg" alt="Drone Images Hosting" width="960" height="841" />
                        </div>
                        <div className="column">
                            <div className="content">
                                <h2 className="title has-text-white is-size-5-mobile is-size-4-tablet is-size-3-desktop is-spaced">บริการ GIS Data Hosting</h2>
                                <p className="subtitle has-text-white-ter is-size-6">สำหรับนัก GIS ที่อยากเก็บข้อมูล Vector และ Raster บนแพลตฟอร์มของเรา</p>
                                <Link to="upload" className="HomeHostingAction button is-primary is-rounded">อัพโหลดข้อมูล GIS</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Hosting;


// WEBPACK FOOTER //
// ./src/PageHome/_Hosting.js